<template>
  <header :class="isActive ? 'top' : ''" id="header">
    <div class="logo" @click="toIndex">
      <img
        :src="screenType == 'computer' ? logoWUrl_com : logoWUrl_mobile"
        alt=""
        v-if="!isActive"
      />
      <!-- <svg-icon iconClass="logo" className="a" v-if="!isActive"></svg-icon> -->
      <img
        :src="screenType == 'computer' ? logoUrl_com : logoUrl_mobile"
        alt=""
        v-if="isActive"
      />
    </div>
    <div :class="{ 'lang-box': true, top3: !isActive }">
      <a href="javascript:void(0);">{{ language }}</a>
      <div class="lang-list">
        <a
          href="javascript:void(0);"
          v-for="item in langList.filter((item) => item.code !== activeLang)"
          :key="item.code"
          @click="changeLang(item.code)"
          >{{ item.lang }}</a
        >
        <!-- <a href="javascript:void(0);" @click="changeLang('zh-cn')"
          >中文</a
        >
        <a href="javascript:void(0);" @click="changeLang('en')">English</a> -->
      </div>
    </div>
    <div @click="showMenu" :class="{ button: true, top2: !isActive }">
      <svg-icon iconClass="header-bread"></svg-icon>
    </div>
    <ul>
      <li
        v-for="(item, index) in menuList"
        :key="item.id"
        :class="{
          color1: isActive,
          active1: item.title == activeTab && !isActive,
          active2: item.title == activeTab && isActive,
        }"
        @click="changeActiveTab(item.title)"
      >
        <router-link :to="item.path">
          <!-- {{ item.title }} -->
          {{ $t("header.menuList[" + index + "]") }}
        </router-link>
      </li>
      <li :class="isActive ? 'color1' : ''" class="lang">
        <a href="javascript:void(0);">{{ language }}</a>
        <div :class="{ 'lang-list': true, bgc: !isActive }">
          <a
            href="javascript:void(0);"
            v-for="item in langList.filter((item) => item.code !== activeLang)"
            :key="item.code"
            @click="changeLang(item.code)"
            >{{ item.lang }}</a
          >
        </div>
      </li>
    </ul>
  </header>
</template>

<script>
import { setItem } from "@/utils/localStorage.js";
export default {
  name: "CmrHeader",
  inject: ["refresh"],
  data() {
    return {
      language: "",
      langList: [
        { lang: "中文", code: "zh-cn", lang_MOBILE: "中文" },
        { lang: "English", code: "en", lang_MOBILE: "EN" },
      ],
      menuList: [
        { id: 0, title: "Company", path: "/company" },
        { id: 1, title: "Solutions", path: "/solutions" },
        { id: 2, title: "Capalities", path: "/capabilities" },
        // { id: 3, title: "Resources", path: "/resourse" },
        { id: 4, title: "Contact", path: "/contact" },
      ],
      isActive: false,
      activeTab: "",
      tab: false,
      isShow_menu: false,
      isShow_lang: false,
      activeLang: "",
      screenType: "",
      logoUrl_com: require("@/assets/images/header/PINK@4x.png"),
      logoUrl_mobile: require("@/assets/images/header/PINK@5x.png"),
      logoWUrl_com: require("@/assets/images/header/WHITE@4x.png"),
      logoWUrl_mobile: require("@/assets/images/header/WHITE@5x.png"),
    };
  },
  methods: {
    Jscroller() {
      //判断顶部
      window.addEventListener("scroll", () => {
        // const clientHeight = document.documentElement.clientHeight;
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        // const scrollHeight = document.documentElement.scrollHeight;
        if (scrollTop <= 100) {
          this.isActive = false;
        } else {
          this.isActive = true;
        }
      });
    },
    toIndex() {
      this.$router.push("/home");
    },
    showMenu() {},
    changeActiveTab(tabName) {
      localStorage.setItem("headerActive", tabName);
    },
    changeLang(lang) {
      setItem("language", lang);
      this.$i18n.locale = lang;
      document.querySelector("html").lang = lang;
      this.refresh();
      if (lang == "zh-cn") {
        document.getElementsByTagName("html")[0].style.fontFamily = "cmr_song";
      } else {
        document.getElementsByTagName("html")[0].style.fontFamily =
          "cmr_gothic";
      }
    },
  },
  mounted() {
    if (localStorage.getItem("language") === "zh-cn") {
      this.language = "中文";
      this.activeLang = "zh-cn";
    } else {
      this.language = "EN";
      this.activeLang = "en";
    }
    this.activeTab = localStorage.getItem("headerActive") || "";
    this.screenType = localStorage.getItem("screenType") || "computer";
    let _this = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "headerActive") {
        // console.log(e.newValue);
        _this.activeTab = e.newValue;
      }
      if (e.key === "screenType") {
        _this.screenType = e.newValue;
        // console.log(e.key)
      }
    });

    // console.log(this.$i18n.getLocaleMessage("cn"));
    // console.log(this.$i18n.locale);
    document.documentElement.scrollTop
      ? (this.isActive = true)
      : (this.isActive = false);
    this.Jscroller();
  },
};
</script>

<style scoped lang="less">
header {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  padding: 0 0.6rem 0 0.6rem;
  top: 0;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  // border-bottom: 0.015rem solid #696664;
  // line-height: 1.5rem;
  .logo {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 1.3rem;
    }
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      position: relative;
      margin-right: 0.8rem;
      height: 100%;
      display: flex;
      align-items: center;
      a {
        font-weight: 500;
        font-size: 0.22rem;
        color: rgb(255, 255, 255);
      }
      &::before {
        display: block;
        position: absolute;
        top: 0;
        content: "";
        width: 100%;
        height: 0.06rem;
        // background-color: rgba(166, 14, 14, 0);
        transition: all 0.5s ease-in-out;
      }
    }
    .lang {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 0.3rem;
      .lang-list {
        background-color: rgb(255, 255, 255);
        flex-direction: column;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateY(0%) translateX(-50%);
        text-align: center;
        display: none;
        a {
          width: 0.8rem;
          color: #000;
          margin: 0.01rem 0;
          &:hover {
            color: #b94060;
          }
        }
      }
      .bgc {
        background-color: rgba(255, 255, 255, 0);
        a {
          color: rgb(255, 255, 255);
        }
      }
      &:hover {
        .lang-list {
          display: flex;
        }
      }
    }
    .lang:hover {
      &::before {
        display: none;
      }
    }
    li:hover {
      cursor: pointer;
      a {
        color: rgb(255, 255, 255);
        font-weight: 500;
      }
      &::before {
        display: block;
        position: absolute;
        top: 0;
        content: "";
        width: 100%;
        height: 0.06rem;
        background-color: rgb(255, 255, 255);
      }
    }
  }
  .button {
    display: none;
    // height: 100%;
  }
  .lang-box {
    display: none;
    // height: 100%;
  }
}

.top {
  background-color: rgba(255, 255, 255, 1);
}

.active1 {
  cursor: pointer;
  a {
    color: rgb(255, 255, 255);
    font-weight: 500;
  }
  &::before {
    display: block;
    position: absolute;
    top: 0;
    content: "";
    width: 100%;
    height: 0.06rem;
    background-color: rgb(255, 255, 255);
  }
}
.active2 {
  cursor: pointer;
  a {
    color: rgb(0, 0, 0);
    font-weight: 500;
  }
  &::before {
    display: block;
    position: absolute;
    top: 0;
    content: "";
    width: 100%;
    height: 0.06rem;
    background-color: rgb(0, 0, 0);
  }
}

.color1 {
  a {
    color: rgb(0, 0, 0);
  }
  &::before {
    // background-color: rgb(0, 0, 0);
  }
  &:hover {
    a {
      color: rgb(0, 0, 0);
    }
    &::before {
      background-color: rgb(0, 0, 0);
    }
  }
}
.color1_lang {
  a {
    color: rgb(0, 0, 0);
  }
}

@media screen and (max-width: 760px) {
  header {
    padding: 0 0.3rem;
    align-items: center;
    .logo {
      img {
        width: 2rem;
        // height: 1.5rem;
      }
    }
    ul {
      position: absolute;
      flex-direction: column;
      display: none;
      width: 100%;
      top: 100%;
      left: 0;
      background-color: #fff;
      li {
        width: 100%;
        margin-right: 0;
        justify-content: center;
        a {
          display: block;
          width: 100%;
          text-align: center;
          height: 1.5rem;
          line-height: 1.5rem;
          font-size: 14px;
          color: #000;
        }
        border-bottom: 0.02rem solid rgb(212, 212, 210);
        border-top: 0.02rem solid rgb(212, 212, 210);
      }
      li:hover {
        a {
          color: #000;
          transition: all 0.5s;
          font-size: 0.5rem;
        }
        &::before {
          display: none;
        }
      }
      .lang {
        display: none;
      }
    }
    ul:hover {
      display: block;
    }
    .lang-box {
      color: rgb(255, 255, 255);
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 0.4rem;
      margin-left: auto;
      margin-right: 0rem;
      a {
        font-size: 14px;
        color: #000;
      }
      &:hover {
        cursor: pointer;
      }
      .lang-list {
        background-color: #fff;
        flex-direction: column;
        position: absolute;
        // bottom: 0%;
        // right: 0%;
        // padding: 0.3rem;
        transform: translateY(100%);
        text-align: center;
        display: none;
        a {
          font-size: 0.3rem;
          width: 2rem;
          color: #000;
          margin: 0.1rem 0;
          &:hover {
            color: #b94060;
          }
        }
      }
      &:hover {
        .lang-list {
          display: flex;
        }
      }
    }
    .top3 {
      a {
        color: rgb(255, 255, 255);
      }
    }
    .button {
      // position: absolute;
      // right: 0;
      // bottom: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px 0 20px;
      flex-shrink: 0;
      height: 50px;
      font-size: 0.6rem;
      color: rgb(0, 0, 0);
      // transform: translateY(50%) translateX(-50%);
      &:hover {
        cursor: pointer;
      }
    }
    .top2 {
      color: rgb(255, 255, 255);
    }
    .button:hover ~ ul {
      display: block;
    }
  }
  .active1 {
    a {
      color: #000;
    }
    &::before {
      display: none;
    }
  }
  .active2 {
    a {
      color: rgb(0, 0, 0);
    }
    &::before {
      display: none;
    }
  }
  .color1:hover {
    a {
      color: rgb(0, 0, 0);
    }
    &::before {
      background-color: rgb(0, 0, 0);
    }
  }
}
</style>
